module.exports = __webpack_public_path__ + "static/blueprint-5ee5cd329be6a9737742fc44ebcae734.jpg";